var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.499 2.99994C9.56902 2.99994 6.37402 6.19494 6.37402 10.1249C6.37402 13.9799 9.38902 17.0999 13.319 17.2349C13.439 17.2199 13.559 17.2199 13.649 17.2349C13.679 17.2349 13.694 17.2349 13.724 17.2349C13.739 17.2349 13.739 17.2349 13.754 17.2349C17.594 17.0999 20.609 13.9799 20.624 10.1249C20.624 6.19494 17.429 2.99994 13.499 2.99994Z",
    fill: "#FC7588"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1204 21.225C16.9354 18.435 10.1104 18.435 5.89543 21.225C3.99043 22.5 2.94043 24.225 2.94043 26.07C2.94043 27.915 3.99043 29.625 5.88043 30.885C7.98043 32.295 10.7404 33 13.5004 33C16.2604 33 19.0204 32.295 21.1204 30.885C23.0104 29.61 24.0604 27.9 24.0604 26.04C24.0454 24.195 23.0104 22.485 21.1204 21.225Z",
    fill: "#FC7588"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.985 11.01C30.225 13.92 28.155 16.47 25.29 16.815C25.275 16.815 25.275 16.815 25.26 16.815H25.215C25.125 16.815 25.035 16.815 24.96 16.845C23.505 16.92 22.17 16.455 21.165 15.6C22.71 14.22 23.595 12.15 23.415 9.9C23.31 8.685 22.89 7.575 22.26 6.63C22.83 6.345 23.49 6.165 24.165 6.105C27.105 5.85 29.73 8.04 29.985 11.01Z",
    fill: "#FC7588"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9854 24.885C32.8654 26.34 31.9354 27.6 30.3754 28.455C28.8754 29.28 26.9854 29.67 25.1104 29.625C26.1904 28.65 26.8204 27.435 26.9404 26.145C27.0904 24.285 26.2054 22.5 24.4354 21.075C23.4304 20.28 22.2604 19.65 20.9854 19.185C24.3004 18.225 28.4704 18.87 31.0354 20.94C32.4154 22.05 33.1204 23.445 32.9854 24.885Z",
    fill: "#FC7588"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.412dcdefceca1eca695fe065e4d285a3.svg";
export { ForwardRef as ReactComponent };